var map = {
  "./code-example/element.js": [
    "84352",
    "6703",
    "6203",
    "1861",
    "6475",
    "7065",
    "7517"
  ],
  "./dropdown/element.js": [
    "58623",
    "2868",
    "4740"
  ],
  "./live-sample-result/element.js": [
    "47849",
    "6703",
    "3611",
    "6203",
    "5950",
    "4098",
    "1861",
    "5330"
  ],
  "./observatory-tests-and-scores/element.js": [
    "56538",
    "6407"
  ],
  "./play-runner/element.js": [
    "63657",
    "6703",
    "5950",
    "4098",
    "4074"
  ],
  "./search-button/element.js": [
    "23745",
    "3690"
  ],
  "./survey/element.js": [
    "70134",
    "6703",
    "6203",
    "2105",
    "2283"
  ],
  "./ix-tab-wrapper/element.js": [
    "49979",
    "2568"
  ],
  "./placement-sidebar/element.js": [
    "57468",
    "6703",
    "3611",
    "8280",
    "1477",
    "4249",
    "2173"
  ],
  "./placement-hp-main/element.js": [
    "44394",
    "6703",
    "3611",
    "8280",
    "1477",
    "4249",
    "4759"
  ],
  "./record-visit/element.js": [
    "55237",
    "5562",
    "3094"
  ],
  "./toggle-sidebar/element.js": [
    "27486",
    "6203",
    "2415"
  ],
  "./user-menu/element.js": [
    "76706",
    "6203",
    "2105",
    "3775"
  ],
  "./interactive-example/element.js": [
    "81505",
    "6703",
    "749",
    "3730",
    "3106",
    "993",
    "6216",
    "2080",
    "640",
    "9515",
    "1356",
    "6203",
    "5950",
    "4098",
    "6760",
    "3047",
    "1861",
    "2448",
    "6475",
    "4419",
    "7065",
    "2568",
    "5338",
    "5722"
  ],
  "./copy-button/element.js": [
    "38262",
    "6203",
    "6475",
    "4660"
  ],
  "./observatory-comparison-table/element.js": [
    "50117",
    "9410",
    "2006"
  ],
  "./sidebar-filter/element.js": [
    "83703",
    "9324"
  ],
  "./issues-table/element.js": [
    "37511",
    "4204"
  ],
  "./scrim-inline/element.js": [
    "43602",
    "6703",
    "3611",
    "5183"
  ],
  "./switch/element.js": [
    "41798",
    "9099"
  ],
  "./collection-save-button/element.js": [
    "1355",
    "6203",
    "3000",
    "4920"
  ],
  "./contributor-list/element.js": [
    "23082",
    "9127"
  ],
  "./button/element.js": [
    "17398",
    "6203",
    "9898"
  ],
  "./homepage-search/element.js": [
    "27373",
    "7678"
  ],
  "./modal/element.js": [
    "14903",
    "6203",
    "3000"
  ],
  "./color-theme/element.js": [
    "55269",
    "2868",
    "544"
  ],
  "./about-team-member/element.js": [
    "612",
    "8981"
  ],
  "./content-feedback/element.js": [
    "83818",
    "6203",
    "4891"
  ],
  "./play-console/element.js": [
    "71787",
    "6760"
  ],
  "./ix-tab/element.js": [
    "18977",
    "4419",
    "5338"
  ],
  "./observatory-header-link/element.js": [
    "1879",
    "9410",
    "3676"
  ],
  "./curriculum-tabs/element.js": [
    "52500",
    "9717"
  ],
  "./placement-bottom/element.js": [
    "7895",
    "6703",
    "3611",
    "8280",
    "1477",
    "4249",
    "4060"
  ],
  "./image-history/element.js": [
    "47706",
    "1975"
  ],
  "./not-found/element.js": [
    "2622",
    "8926",
    "3555"
  ],
  "./placement-note/element.js": [
    "47764",
    "1477"
  ],
  "./compat-table-lazy/element.js": [
    "96678",
    "6703",
    "2105",
    "6002",
    "251"
  ],
  "./site-search/element.js": [
    "41425",
    "6203",
    "9578"
  ],
  "./placement-no/element.js": [
    "13755",
    "8280"
  ],
  "./play-controller/element.js": [
    "23731",
    "2448"
  ],
  "./placement-top/element.js": [
    "9951",
    "6703",
    "3611",
    "8280",
    "1477",
    "4249",
    "9204"
  ],
  "./observatory-form/element.js": [
    "17547",
    "6703",
    "6203",
    "6110",
    "8364"
  ],
  "./observatory-results/element.js": [
    "13430",
    "6203",
    "9410",
    "2868",
    "6110",
    "2006",
    "7593",
    "3676",
    "4070",
    "3259"
  ],
  "./about-tabs/element.js": [
    "54842",
    "7047"
  ],
  "./observatory-human-duration/element.js": [
    "37077",
    "9410",
    "4070"
  ],
  "./playground/element.js": [
    "71026",
    "6703",
    "749",
    "3730",
    "3106",
    "993",
    "6216",
    "2080",
    "640",
    "9515",
    "6203",
    "5950",
    "4098",
    "6760",
    "3047",
    "2448",
    "3000",
    "893"
  ],
  "./ix-tab-panel/element.js": [
    "89854",
    "4419"
  ],
  "./play-editor/element.js": [
    "63386",
    "749",
    "3730",
    "3106",
    "993",
    "6216",
    "2080",
    "640",
    "9515",
    "5950",
    "3047"
  ],
  "./themed-image/element.js": [
    "48125",
    "5102"
  ],
  "./writer-open-editor/element.js": [
    "51310",
    "6203",
    "9967"
  ],
  "./progress-bar/element.js": [
    "20141",
    "6110"
  ],
  "./compat-table/element.js": [
    "12969",
    "6703",
    "2105",
    "6002"
  ],
  "./login-button/element.js": [
    "70242",
    "6203",
    "6067"
  ],
  "./observatory-rescan-button/element.js": [
    "14416",
    "6203",
    "7593",
    "3140"
  ],
  "./recently-visited/element.js": [
    "95821",
    "5562",
    "5246"
  ],
  "./language-always-redirect-button/element.js": [
    "77108",
    "8300",
    "5685"
  ],
  "./language-switcher/element.js": [
    "64786",
    "2868",
    "9099",
    "8300",
    "8926",
    "5667"
  ],
  "./search-modal/element.js": [
    "97154"
  ],
  "./writer-reload/element.js": [
    "14925",
    "4366"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 98693;
module.exports = __rspack_async_context;
